import { ToolTip } from "@/components";
import { cn } from "@/lib/utils";
import { CaretSortIcon } from "@radix-ui/react-icons";
import { Column } from "@tanstack/react-table";
import { ComponentProps, useCallback } from "react";

type ColumnHeaderProps<TData, TValue> = {
  column: Column<TData, TValue>;
  title: string;
} & ComponentProps<"div">;

export function ColumnHeader<TData, TValue>({
  column,
  title,
  className,
  ...props
}: ColumnHeaderProps<TData, TValue>) {
  const toggleSort = useCallback(
    () => column.toggleSorting(column.getIsSorted() === "asc"),
    [column]
  );

  return (
    <ToolTip title="Alterar ordem">
      <div
        onClick={toggleSort}
        className={cn(
          "text-[#969696] w-full inline-flex items-center rounded-none hover:shadow-none font-bold",
          className
        )}
        {...props}
      >
        {title}
        <CaretSortIcon className="h-4 w-4" />
      </div>
    </ToolTip>
  );
}
